__turbopack_context__.v({
  "checkContainer": "Checkbox-module__rIcRua__checkContainer",
  "checkContainerChecked": "Checkbox-module__rIcRua__checkContainerChecked",
  "label": "Checkbox-module__rIcRua__label",
  "labelBoxCell": "Checkbox-module__rIcRua__labelBoxCell",
  "labelTable": "Checkbox-module__rIcRua__labelTable",
  "labelTextCell": "Checkbox-module__rIcRua__labelTextCell",
  "visuallyHiddenInput": "Checkbox-module__rIcRua__visuallyHiddenInput",
});
